import { userConstants } from "../_constants";
import {
  clearSession,
  isAuthenticated,
  parseStoredUser,
} from "../_helpers/auth";

const storedUser = parseStoredUser();
let initialState = {};

if (isAuthenticated()) {
  initialState = {
    loggedIn: true,
    user: storedUser,
  };
} else if (storedUser) {
  clearSession();
}

export function authentication(state = initialState, action) {
  console.log("action", action);
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        user: action.user,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        loggedIn: false,
        error: action.error,
      };
    case userConstants.LOGOUT:
      return {};
    default:
      return state;
  }
}
